var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlusInABox = function SvgPlusInABox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39999 4.00002C2.39999 3.11637 3.11634 2.40002 3.99999 2.40002H20C20.8836 2.40002 21.6 3.11637 21.6 4.00002V20C21.6 20.8837 20.8836 21.6 20 21.6H3.99999C3.11634 21.6 2.39999 20.8837 2.39999 20V4.00002ZM3.99999 3.60002C3.77908 3.60002 3.59999 3.77911 3.59999 4.00002V20C3.59999 20.2209 3.77908 20.4 3.99999 20.4H20C20.2209 20.4 20.4 20.2209 20.4 20V4.00002C20.4 3.77911 20.2209 3.60002 20 3.60002H3.99999ZM11.4 12.6V17H12.6V12.6H17V11.4H12.6V7.00002H11.4V11.4H6.99999V12.6H11.4Z"
  })));
};
export default SvgPlusInABox;